import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

// Space
const getSpaces = () => axios.get(`${API_URL}/spaces`)
  .then(response => response.data);

const getSpace = spaceId => axios.get(`${API_URL}/spaces/${spaceId}`)
  .then(response => response.data);

// Entity
const getEntity = (spaceId, entityId) => axios.get(`${API_URL}/spaces/${spaceId}/entities/${entityId}`)
  .then(response => response.data);

const getEntities = spaceId => axios.get(`${API_URL}/spaces/${spaceId}/entities`)
  .then(response => response.data);

// Content
const getContent = (spaceId, entityId, contentId, locale) => axios.get(`${API_URL}/spaces/${spaceId}/entities/${entityId}/contents/${contentId}?locale=${locale}`)
  .then(response => response.data);

const getContents = (spaceId, entityId) => axios.get(`${API_URL}/spaces/${spaceId}/entities/${entityId}/contents`)
  .then(response => response.data);

const createContent = (spaceId, entityId, content) => axios.post(`${API_URL}/spaces/${spaceId}/entities/${entityId}/contents`, content)
  .then(response => response.data);

const deleteContent = (spaceId, entityId, contentId) => axios.delete(`${API_URL}/spaces/${spaceId}/entities/${entityId}/contents/${contentId}`)
  .then(response => response.data);


// Version
const getVersion = (spaceId, entityId, contentId, versionId) => axios.get(`${API_URL}/spaces/${spaceId}/entities/${entityId}/contents/${contentId}/versions/${versionId}`)
  .then(response => response.data);

const getVersions = (spaceId, entityId, contentId, locale) => axios.get(`${API_URL}/spaces/${spaceId}/entities/${entityId}/contents/${contentId}/versions?locale=${locale}`)
  .then(response => response.data);

const saveVersion = (spaceId, entityId, contentId, version) => axios.post(`${API_URL}/spaces/${spaceId}/entities/${entityId}/contents/${contentId}/versions`, version)
  .then(response => response.data);

const updateVersion = (spaceId, entityId, contentId, versionId, version) => axios.patch(`${API_URL}/spaces/${spaceId}/entities/${entityId}/contents/${contentId}/versions/${versionId}`, version)
  .then(response => response.data);


// Madia
const getMedia = spaceId => axios.get(`${API_URL}/spaces/${spaceId}/media`)
  .then(response => response.data);

const deleteMedia = (spaceId, mediaId) => axios.delete(`${API_URL}/spaces/${spaceId}/media/${mediaId}`)
  .then(response => response.data);

const getUploadMediaUrl = spaceId => `${API_URL}/spaces/${spaceId}/media`;

const api = {};
api.getSpace = getSpace;
api.getSpaces = getSpaces;

api.getEntity = getEntity;
api.getEntities = getEntities;

api.getContent = getContent;
api.getContents = getContents;
api.createContent = createContent;
api.deleteContent = deleteContent;

api.getVersion = getVersion;
api.getVersions = getVersions;
api.saveVersion = saveVersion;
api.updateVersion = updateVersion;

api.getMedia = getMedia;
api.deleteMedia = deleteMedia;
api.getUploadMediaUrl = getUploadMediaUrl;

export default api;
